import type { ReactNode } from 'react'
import { cn } from '../../utils/cn'

export interface SectionHeadingProps {
  /** Small caps line above the title — Stitch's "Our Expertise" eyebrow. */
  eyebrow?: string
  title: ReactNode
  body?: ReactNode
  action?: ReactNode
  align?: 'left' | 'center'
  className?: string
}

export function SectionHeading({ eyebrow, title, body, action, align = 'left', className }: SectionHeadingProps) {
  return (
    <div
      className={cn(
        'mb-12 flex flex-col gap-4 md:mb-16',
        align === 'center' ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between',
        className,
      )}
    >
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="mb-4 block font-label-caps text-label-caps uppercase tracking-widest text-primary">
            {eyebrow}
          </span>
        )}
        <h2 className="font-display text-headline-md text-on-surface">{title}</h2>
        {body && <p className="mt-3 font-body-md text-body-md text-on-surface-variant">{body}</p>}
      </div>
      {action}
    </div>
  )
}
